import { withCurrentParams } from 'actions/utils';
import { BANNER_LIVE_TOGGLE } from 'store/eventConstants';
import { BROADCAST_TOGGLE_BANNER_HIDDEN } from 'actions/Types';

export default bannerId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        banners,
        meeting: { attendeeResponse }
      } = getState();
      const banner = banners.find(banner => banner._id === bannerId);
      const hidden = !banner.source.hidden;

      const payload = {
        source: {
          hidden
        }
      };

      const action = {
        type: BROADCAST_TOGGLE_BANNER_HIDDEN,
        request: async apiClient => {
          const broadcast = await apiClient.broadcast.updateBanner(
            teamId,
            eventId,
            broadcastId,
            bannerId,
            payload
          );

          const { banners } = broadcast;
          // notify other directors
          socket.emit(BANNER_LIVE_TOGGLE, {
            bannerId,
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return banners;
        }
      };
      dispatch(action);
    }
  );
};
